module.exports = __webpack_public_path__ + "img/menuboard-cho-express-small.ab9d2f7c.png";